export const actions = {
  set_state: 'roles/set_state',
  get_roles: 'roles/get_roles',
  delete_roles: 'roles/delete_roles',
  update_roles: 'roles/update_roles',
  create_roles: 'roles/create_roles',
  create_permission: 'permission/create_permission',
  get_permission: 'permission/get_permission'
}
